import type { DataTableColumn } from '@/components/custom/erp';
import type { DotThanhToan } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<DotThanhToan>[] => [
  {
    field: 'ma_dtt',
    headerName: 'Mã đợt',
    width: 150
  },
  {
    field: 'ten_dtt',
    headerName: 'Tên đợt thanh toán',
    width: 250
  },
  {
    field: 'stt',
    headerName: 'Số thứ tự',
    width: 120
  }
];
